
(function(template){
define('vue!app/views/vue/components/cartComponent/cart',[
  "Vue",
  "vuex",
  "helpers",
  "vue!./cartBody/container",
  "moment",
  "vue!app/views/vue/components/cartComponent/addGuestComponent/container",
  'vue!./popupLoginComponent/componentPopUp'
], function(Vue, vuex, helpers, cartBody, moment, logIn, popupLoginComponent) {
  return {
    template: template,
    components: {
      "cart-body": cartBody,
      "log-in": logIn,
      'popup-login-component' : popupLoginComponent
    },
   computed: _.extend(
      vuex.mapState(["showSummaryOnSideBar",'showMobileItineraryDropDown','mobileCategoryShow','users','editingFolioItemId','status','guestProfiles']),{
      desktopMode: function(){
        return this.$store.state.desktopMode;
      },
      activeStep: function(){
        return this.$store.state.activeStep;
      },
      HiddenReservedPackageItems:function(){
        return this.$store.state.HiddenReservedPackageItems
      },
      currentUserId:function(){
        return this.$store.state.currentUserId
      },
      isCartEmpty: function(){
        var empty = true
        _.each(this.users,function(bookings){
         !_.isEmpty(bookings) ? empty = false : ''
        })
        return empty
      }
      })
    ,  
    methods: _.extend(vuex.mapMutations(["nextStep","removeSingleService","setActiveStep",'changeActiveService']), {
   
      showCart: function() {
        console.log("i ran",this.showMobileItineraryDropDown)
        var changedVal = !this.showMobileItineraryDropDown
       this.$store.commit('setShowMobileItineraryDropDown',changedVal)
     
      },
      toggleCheckbox: function() {
        this.$store.commit(
          "setshowSummaryOnSideBar",
          !this.showSummaryOnSideBar
        );
      },
      hide:function(){
      // this.$store.commit('setShowMobileItineraryDropDown',!this.showMobileItineraryDropDown)
       if(this.showMobileItineraryDropDown == true)   this.$store.commit('setShowMobileItineraryDropDown',false)
      },
      performAction:function(){
        if(!this.desktopMode && !this.mobileCategoryShow && this.activeStep==0){
          this.$store.commit('setmobileCategoryShow',!this.mobileCategoryShow)
        }
       else if(this.activeStep ==0 ){
          app.dispatcher.redirect('spaBooking'); // take user to spa location selection
        }
        else{
       // this.AddHiddenPackageItemsToReserved()
        this.setActiveStep(this.activeStep-1)
        }
         this.$store.commit('setShowMobileItineraryDropDown',false)
      },
      handleResize: function() {
        var bool = window.innerWidth > 768 ? true : false;
        this.$store.commit("changeDesktopMode", bool);
        this.$store.commit("setshowSummaryOnSideBar", bool);
      },
      AddHiddenPackageItemsToReserved: function() {
        var vm = this;
        console.log(" hidden was ran in cart");
        if (Object.keys(vm.HiddenReservedPackageItems).length > 0) {
          var userID = Object.keys(vm.HiddenReservedPackageItems)[0];
          vm.HiddenReservedPackageItems[userID].forEach(function(item) {
            var payload = {
              data: {
                StartTime: item.dateTime,
                EndTime: moment(item.dateTime, "YYYY-MM-DDHHmmss")
                  .add(item.ServiceTime, "minutes")
                  .format("YYYY-MM-DDHHmmss"),
                activity: item.ItemName,
                SpaItemId: item.SpaItemId,
                isFutureBooking: false,
                SpaFolioItemId: item.SpaFolioItemId
              },
              id: userID
            };
            vm.$store.commit("addReservedTime", payload);
          //  vm.$store.commit("AddHiddenReservedTime", {});
          });
        }
      }
    }),
    data: function() {
      return {
        mobileShowCartBody: false,
        sticky: false,
        val: 0
      };
    },
    watch:{
      showMobileItineraryDropDown:function(val){
      this.$store.commit("setIsBodyBlur", val)

      }
    },
    mounted: function() {
      var vm = this;
		helpers.fetchGroupMembers().then(function (groupMembers) {
			groupMembers.GroupMember.forEach(function (member) {
				vm.$store.commit('addGroupMember', member.Name.FirstName + " " + member.Name.LastName);
        vm.$store.commit('addUserWithId', {name: member.Name.FirstName + " " + member.Name.LastName, id: member.CustomerId});
        //part of age restriction; storing guest profile

          var modifedProfile = _.extend({}, vm.guestProfiles[member.CustomerId], member)

        vm.$store.commit('addGuestProfile',modifedProfile)
			})
      helpers.matchStoreWithFolio();
		});
      	//for closing cart when clicked on edit
        this.$root.$on('closeCart',function(data) {
         this.$store.commit('setShowMobileItineraryDropDown',data)
        })
    },

    created: function() {
      window.addEventListener("resize", this.handleResize);
      window.addEventListener("scroll", this.test);
      this.handleResize();
    },
    destroyed: function() {
      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("scroll", this.test);
    }
  };
});
})('<div id="vue-cart" v-click-outside="hide"> <div class="cart-header" :class="desktopMode? \'yellowHeader\':null"> <!-- <div id="vue-cart-back" v-on:click="performAction" :class="activeStep == 0 ? \'disabled\' : null">{{localStrings.sideCart.backButtonText}}</div> --> <div> <i class="fas fa-arrow-left vue-cart-back-icon" v-on:click="performAction" v-show=" !desktopMode && activeStep!=2" ></i></div> <h3> <div v-if="desktopMode"> <!-- <strong>{{localStrings.sideCart.header}}</strong> --> <!-- <label class="sidebar_switch"> <input type="checkbox" @click="toggleCheckbox" /> <span class="sidebar_slider round"></span> </label> <strong>Show Itinerary</strong> --> </div> <div v-else v-show="!isCartEmpty"> <strong @click="showCart">{{localStrings.sideCart.cart}}</strong> <i @click="showCart" v-if="!desktopMode " :class="showMobileItineraryDropDown ? \'fa fa-chevron-up\' : \'fa fa-chevron-down\' " data-toggle="collapse" data-target="#demo" ></i> </div> </h3> <div @click="hide"> <!-- <log-in v-if="!desktopMode"></log-in> --> <popup-login-component v-if="!desktopMode"></popup-login-component> </div> </div> <cart-body :showCart="showCart" v-bind:view_summary="showSummaryOnSideBar" v-show="showMobileItineraryDropDown || desktopMode"></cart-body> </div>');
